export default function (...classNames: (string | undefined)[]) {
  classNames = classNames.filter(className => className !== undefined)
  return classNames.join(' ')
}
